import { Injectable }               from '@angular/core';
import { Http }                     from '@angular/http';
import { ISortableFilter }          from './../common/sortable-filter';
import { Globals }                  from './../common/globals';
import { AuthHttp }                 from 'angular2-jwt';
import { Observable }               from 'rxjs/Observable';
import { GridInterfaceService }     from './grid.interface.service';
import { CommonService }            from './common.service';
import { MatSnackBar }               from '@angular/material';

@Injectable()
export class BusCrewService implements GridInterfaceService {

    private _commonService: CommonService;

    constructor(public authHttp: AuthHttp, private http: Http, private globals: Globals, public snackbar: MatSnackBar) {
        this._commonService = new CommonService(authHttp, http, globals, 'busCrew', snackbar);
    }

    public getItems(filter: ISortableFilter): Observable<any> {
        return this._commonService.getItems(filter);
    }

    public getCrewByBus(id: number): Observable<any> {
        return this._commonService.post('busId/' + id, {});
    }

    public getPrimaryDrivers(): Observable<any> {
        return this._commonService.get('primary/');
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/shared/bus-crew.service.ts